import React, { useState } from "react";
import { Button } from "reactstrap";
import { Markdown } from "components/Markdown";
import "./multipleChoice.scss";

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function MultipleChoice(props) {
  const { exercise, selectedAnswer, onChange } = props;
  const { altChoices } = exercise.collector;

  const [choices] = useState(
    props.exercise.collector.shouldNotShuffle
      ? altChoices
      : shuffleArray([props.exercise.answer, ...altChoices])
  );

  return (
    <div className="choices pr text">
      {choices.map((val, i) => {
        const isSelected = val === selectedAnswer,
          isCorrect = val === exercise.answer,
          color =
            selectedAnswer && isCorrect
              ? "success"
              : selectedAnswer && isSelected
              ? "danger"
              : null;
        return (
          <Button
            key={i}
            className={`choice`}
            color={color}
            onClick={() => onChange(val)}
            disabled={selectedAnswer !== null}
            active={isSelected}
          >
            <Markdown transparent>
              {exercise.collector.representationType !== "Code" ? val :
                 `\`\`\`${exercise.collector.codingLanguage}\n${val}\n\`\`\``
              }
            </Markdown>
          </Button>
        );
      })}
    </div>
  );
}

export { MultipleChoice };
